import React from "react";
import { Text, View } from "react-native";
import { RsvpTone, useRsvpColors } from "../theme";
import RsvpPrimaryButton from "./RsvpPrimaryButton";
import RsvpScaffold from "./RsvpScaffold";
import RsvpStatusIcon, { RsvpIconName } from "./RsvpStatusIcon";

interface Props {
  icon: RsvpIconName;
  tone: RsvpTone;
  title: string;
  body?: string;
  actionText?: string;
  onAction?: () => void;
}

const RsvpMessage: React.FC<Props> = ({
  icon,
  tone,
  title,
  body,
  actionText,
  onAction,
}) => {
  const colors = useRsvpColors();
  return (
    <RsvpScaffold>
      <View style={{ alignItems: "center" }} accessibilityRole="alert">
        <View style={{ marginBottom: 16 }}>
          <RsvpStatusIcon name={icon} tone={tone} />
        </View>
        <Text
          style={{
            color: colors.textPrimary,
            fontSize: 24,
            fontWeight: "700",
            textAlign: "center",
            marginBottom: 8,
          }}
        >
          {title}
        </Text>
        {body ? (
          <Text
            style={{
              color: colors.textMuted,
              fontSize: 16,
              textAlign: "center",
            }}
          >
            {body}
          </Text>
        ) : null}
        {actionText && onAction ? (
          <RsvpPrimaryButton
            title={actionText}
            onPress={onAction}
            style={{ marginTop: 24, alignSelf: "stretch" }}
          />
        ) : null}
      </View>
    </RsvpScaffold>
  );
};

export default RsvpMessage;
